import apiClient from "../common/apiClient.js";

export default class InternetProfileController {
  async Create(data, token) {
    try {
      return await apiClient.post("/tenant/internetProfile/", data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
    } catch (error) {
      return error;
    }
  }
  async Update(data, token) {
    try {
      return await apiClient.put("/tenant/internetProfile/", data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
    } catch (error) {
      return error;
    }
  }

  async Get(tenantId, token) {
    try {
      return await apiClient.get(
        "/tenant/internetProfile/" + tenantId,
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (error) {
      return error;
    }
  }
}
